var map = {
	"./block-diagram.svg": 63252,
	"./chen-erd.svg": 50373,
	"./circle-spoke-diagram.svg": 22982,
	"./circuit.svg": 61834,
	"./concept-map.svg": 65662,
	"./floorplan.svg": 7260,
	"./flow-chart.svg": 95314,
	"./gantt.svg": 67773,
	"./genogram.svg": 61069,
	"./icon-empty.svg": 5566,
	"./icon-master.svg": 15437,
	"./icon-max.svg": 151,
	"./icon-pixso.svg": 36316,
	"./icon-project.svg": 62974,
	"./mind-mapping.svg": 32736,
	"./network.svg": 3253,
	"./org-chart-auto.svg": 66478,
	"./process-p&id.svg": 62024,
	"./roadmap.svg": 88435,
	"./software-arch.svg": 40279,
	"./swimlane.svg": 91239,
	"./uml.svg": 62237
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18993;